import {
  DateRangePicker as MuiDateRangePicker,
  DateRangePickerProps as MuiDateRangePickerProps,
} from "@mui/x-date-pickers-pro/DateRangePicker";
import { DateRange } from "@mui/x-date-pickers-pro/models";
import {
  StaticDateRangePicker as MuiStaticDateRangePicker,
  StaticDateRangePickerProps as MuiStaticDateRangePickerProps,
} from "@mui/x-date-pickers-pro/StaticDateRangePicker";
import {
  PickersShortcutsItem as MuiPickersShortcutsItem,
  PickersShortcutsProps as MuiPickersShortcutsProps,
} from "@mui/x-date-pickers/PickersShortcuts";
import { Dayjs } from "dayjs";

export type DateRangePickerProps = MuiDateRangePickerProps<Dayjs>;
export type StaticDateRangePickerProps = MuiStaticDateRangePickerProps<Dayjs>;
export type PickersShortcutsItem = MuiPickersShortcutsItem<DateRange<Dayjs>>;
export type PickersShortcutsProps = MuiPickersShortcutsProps<DateRange<Dayjs>>;

export const DateRangePicker: React.FunctionComponent<DateRangePickerProps> =
  MuiDateRangePicker;
export const StaticDateRangePicker: React.FunctionComponent<StaticDateRangePickerProps> =
  MuiStaticDateRangePicker;
export { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
